import React from 'react';
const WorkflowDiagramContext = React.createContext({});
export const WorkflowDiagramProvider = WorkflowDiagramContext.Provider
export default WorkflowDiagramContext;
